module.exports = __webpack_public_path__ + "img/chevron-left-solid -colortext2.a6a3b3f7.svg";